import request from "root/js/request";

export const getSharesTableProductCounts = async ({ cabinet_id, shares_id }) => {
  const response = await request({
    url: `/api/analytics/shares_table/product_status/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "get",
  });

  return response.data;
};
